export default {
  addressForm: {
    lookUpAddress: {
      title: "Rechercher l'adresse",
      saveButton: 'OK',
      fields: {
        country: 'Pays',
        address: 'Adresse',
      },
      extra: {
        loading: 'Récupérer',
        noResults: 'Aucun résultat trouvé',
      },
    },
  },
  createCustomer: {
    errorText: {
      loyaltyCardNumber: {
        invalid: 'Ce champ doit contenir un numéro à 8 ou 9 chiffres valide',
        checking: 'Checking...',
        alreadyExists: 'Ce numéro de carte client existe déjà',
      },
    },
    fields: { language: 'Langue' },
    languages: {
      english: 'Anglais',
      french: 'Français',
    },
  },
};
